import React from 'react'
import Navbar from '../../widgets/Navbar'

const Tours = () => {
    return (
        <>
            <Navbar />
            <section className={'careersContainer'}>
                <header>
                    <h2>
                        TOURS
                    </h2>
                    <p>
                        Follow us as we tour around the world spreading good music for the soul
                    </p>
                    <p>
                        Coming Soon...
                    </p>
                </header>
            </section>
        </>
    )
}

export default Tours